module.exports = __webpack_public_path__ + "static/media/percentage.45f1eff5.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/badges/percentage.svg
 ** module id = 423
 ** module chunks = 0
 **/